import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AuthContainer,
  AuthCard,
  AuthHeader,
  AuthSubtitle,
  AuthForm,
  FormField,
  FormLabel,
  FormInput,
  PasswordInput,
  PasswordInputField,
  TogglePasswordButton,
  FormActions,
  AuthButton,
  AuthFooter,
  AuthAlt,
  AuthLink
} from '../../styles/AuthStyles';
import { LoginApi, MyAccounts } from '../../common/CommonApi';
import { useDispatch } from "react-redux";
import { loginSuccess } from '../../store/slices/auth';
const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = await LoginApi({ email, password });

    if (data && data.status === 200) {
      dispatch(
        loginSuccess({
          token: data.data.data.token,
          refreshToken: data.data.data.refreshToken,
        })
      );

      const res = await MyAccounts();
      const resolvedIsDocs = Boolean(res?.isDocs);
      const resolvedIsDocsPending = Boolean(res?.isDocsPending);

      dispatch(
        loginSuccess({
          token: data.data.data.token,
          refreshToken: data.data.data.refreshToken,
          _id: res?._id,
          permissions: res?.permissions,
          email: res?.email,
          fullname: res?.fullname,
          isDocs: resolvedIsDocs,
          isDocsPending: resolvedIsDocsPending,
        })
      );

      navigate('/dashboard');
    }
  };

  return (
    <AuthContainer>
      <AuthCard>
        <AuthHeader>
          <img src='./assets/logo.png' alt="Logo" style={{width:"150px"}}/>
          <AuthSubtitle>Sign in to your account</AuthSubtitle>
        </AuthHeader>

        <AuthForm onSubmit={handleSubmit}>
          <FormField>
            <FormLabel htmlFor="email">Email</FormLabel>
            <FormInput
              id="email"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </FormField>

          <FormField>
            <FormLabel htmlFor="password">Password</FormLabel>
            <PasswordInput>
              <PasswordInputField
                id="password"
                type={showPassword ? 'text' : 'password'}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
              <TogglePasswordButton
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? 'Hide' : 'Show'}
              </TogglePasswordButton>
            </PasswordInput>
          </FormField>

          <FormActions>
            <AuthButton type="submit">Sign in</AuthButton>
          </FormActions>
        </AuthForm>

        {/* <AuthFooter>
          <AuthAlt>
            Don't have an account? <AuthLink href="/signup">Register</AuthLink>
          </AuthAlt>
          <AuthAlt>
            Don't have an account? <AuthLink href="/partner-form">Be a Partner</AuthLink>
          </AuthAlt>
        </AuthFooter> */}
      </AuthCard>
    </AuthContainer>
  );
};

export default Login;
